module.exports = __webpack_public_path__ + "assets/img/mask-bg4.23b36bdc.png";